import { render, staticRenderFns } from "./deleteInsight.vue?vue&type=template&id=563c962c"
import script from "./deleteInsight.vue?vue&type=script&lang=js"
export * from "./deleteInsight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports